import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Descriptions,
  Avatar,
  notification,
  Image,
} from "antd";
import BgProfile from "../assets/images/bg-signup.jpg";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../config";
import Loader from "../components/Loader";
import femaleImageBlank from '../assets/images/femaleAvatar.jpg'
import maleImageBlank from '../assets/images/maleAvatar.jpg'

function Profile() {
  const { userId } = useParams();
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUser();
  }, []); // Update data when page or page size changes

  async function getUser() {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/api/user/read/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.status === 200) {
        setUserData(response.data.result);
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight',
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  }

  const formatStorage = (bytes) => {
    if (!bytes) return "0";
    const gb = bytes / (1024 ** 3);
    if (gb >= 1) {
      return `${gb.toFixed(2)} GB`;
    }
    const mb = bytes / (1024 ** 2);
    return `${mb.toFixed(2)} MB`;
  };

  const activeSub = userData?.subscription?.length > 0
    ? (userData.subscription.find(s => s.status === 'active' || s.status === 'trialing') || userData.subscription[userData.subscription.length - 1])
    : null;
  const subStartDate = activeSub?.transactionDate || activeSub?.updatedAt || activeSub?.createdAt || userData?.updatedAt || userData?.planId?.updatedAt;
  const subEndDate = activeSub?.expireDate || (subStartDate ? new Date(new Date(subStartDate).getTime() + 30 * 24 * 60 * 60 * 1000) : null);

  return (
    <>
      <Loader visible={loading} />
      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      <Card
        className="card-profile-head"
        bodyStyle={{ display: "none" }}
        title={
          <Row justify="space-between" align="middle" gutter={[24, 0]}>
            <Col span={24} md={12} className="col-info">
              <Avatar.Group>
                <Image width={80} height={80} size={74} shape="square" src={
                  userData?.photo
                    ? `${userData?.photo}`
                    : userData?.gender === 'female'
                      ? femaleImageBlank
                      : maleImageBlank
                } />

                <div className="avatar-info">
                  <h4 className="font-semibold m-0">{`${userData?.firstName || ''} ${userData?.lastName || ''}`}</h4>
                  {/* <p>{userData?.email}</p> */}
                  <p>{userData?.bio}</p>
                </div>
              </Avatar.Group>
            </Col>
            <Col
              span={24}
              md={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {userData?.video && userData?.video !== 'undefined' && (
                <video
                  width="150"
                  height="100"
                  controls
                >
                  <source src={userData?.video?.startsWith('http') ? userData?.video : `${baseUrl}/${userData?.video}`} type="video/mp4" />
                </video>
              )}
            </Col>
          </Row>
        }
      ></Card>

      <Row gutter={[24, 0]}>
        <Col span={24} md={12} className="mb-24 ">
          <Card
            bordered={false}
            // title={<h6 className="font-semibold m-0">Basic Information</h6>}
            className="header-solid h-full card-profile-information"
            // extra={<Button type="link">{pencil}</Button>}
            bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
          >
            <Descriptions title="Basic Information" style={{ marginTop: 30 }}>
              <Descriptions.Item label="Total Followers" span={3}>
                {userData?.followers?.length || 0}
              </Descriptions.Item>
              <Descriptions.Item label="Total Following" span={3}>
                {userData?.following?.length || 0}
              </Descriptions.Item>
              <Descriptions.Item label="Total Blog" span={3}>
                <Link to={`/blog-management?user=${userData?._id}`}>{userData?.blogCount}</Link>
              </Descriptions.Item>
              <Descriptions.Item label="Total Idea" span={3}>
                <Link to={`/ideas?user=${userData?._id}`}>{userData?.ideaCount}</Link>
              </Descriptions.Item>
              <Descriptions.Item label="Total Idea Purchased" span={3}>
                <Link to={`/idea-purchase?user=${userData?._id}`}>{userData?.purchases?.length}</Link>
              </Descriptions.Item>
              <Descriptions.Item label="Total Question" span={3}>
                <Link to={`/questions?user=${userData?._id}`}>{userData?.questionCount}</Link>
              </Descriptions.Item>
              <Descriptions.Item label="Interested Categories" span={3}>
                {userData?.category?.map(cat => cat.title).join(', ')}
              </Descriptions.Item>
              <Descriptions.Item label="Total Storage" span={3}>
                {formatStorage(userData?.storageLimit)}

              </Descriptions.Item>

              <Descriptions.Item label="Used Storage" span={3}>
                {formatStorage(userData?.storageUsed)}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col span={24} md={12} className="mb-24">
          <Card
            bordered={false}
            // title={<h6 className="font-semibold m-0">Profile Information</h6>}
            className="header-solid h-full card-profile-information"
            // extra={<Button type="link">{pencil}</Button>}
            bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
          >
            <Descriptions className="my-25" title="Personal Information">
              <Descriptions.Item label="Email" span={3}>
                {userData?.email}
              </Descriptions.Item>
              {/* <Descriptions.Item label="DOB" span={3}>
                {new Date(userData?.dob).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'long', // This will display the full month name
                  year: 'numeric',
                })}
              </Descriptions.Item> */}
              <Descriptions.Item label="Location" span={3}>
                {userData?.country ? (userData?.city ? `${userData.city}, ${userData.country}` : userData.country) : userData?.locationNow}
              </Descriptions.Item>
              <Descriptions.Item label="Total earning" span={3}>
                €{userData?.paymentHistory?.total_earning}
              </Descriptions.Item>
              <Descriptions.Item label="Available for withdrawal" span={3}>
                €{userData?.paymentHistory?.available_withdraw_amount}
              </Descriptions.Item>
              <Descriptions.Item label="Pending earning amount" span={3}>
                €{userData?.paymentHistory?.pending_earnings}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col span={24} md={12} className="mb-24">
          <Card
            bordered={false}
            className="header-solid h-full"
            bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
          >
            <Descriptions className="my-25" title="Subscription Plan">
              <Descriptions.Item label="Plan" span={3}>
                {userData?.planId?.name}
              </Descriptions.Item>
              <Descriptions.Item label="Price" span={3}>
                {userData?.planId?.price > 0
                  ? `€${userData?.planId?.price}`
                  : "Free"}
              </Descriptions.Item>
              <Descriptions.Item label="Subscription Status" span={3}>
                {userData?.planId?.isActive ? "Active" : "Inactive"}
              </Descriptions.Item>
              <Descriptions.Item label="Subscription Start Date" span={3}>
                {subStartDate
                  ? new Date(subStartDate).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })
                  : 'N/A'}
              </Descriptions.Item>
              {userData?.planId?.price > 0 && (
                <Descriptions.Item label="Subscription End Date" span={3}>
                  {subEndDate ? (
                    new Date(subEndDate).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric',
                    })
                  ) : (
                    'N/A'
                  )}
                </Descriptions.Item>
              )}


            </Descriptions>
          </Card>
        </Col>
      </Row>

    </>
  );
}

export default Profile;
